import React, { useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Menu,
  IconButton,
} from "@mui/material";
import brandLogo from "./assets/codelab admin left.png";
import { useMsal } from "@azure/msal-react";
import { useEventContext } from "./contexts/EventContext";
import { useProfileContext } from "./contexts/ProfileContext";
import { FaUserCircle, FaArrowCircleRight } from "react-icons/fa";

const FONT_STYLE = { fontFamily: "Verdana", fontSize: "13px" };

const Header: React.FC = () => {
  const { instance } = useMsal();
  const { events, selectedEventId, setSelectedEventId } = useEventContext();
  const { profile } = useProfileContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleEventChange = (e: SelectChangeEvent<string>) => {
    setSelectedEventId(e.target.value as string);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    instance.logoutPopup();
  };

  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0.5rem 1rem",
        backgroundColor: "#fafafa",
        position: "relative",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={brandLogo}
            alt="CodeLab Admin"
            style={{ height: "42px", objectFit: "contain", minWidth: 140 }}
          />
        </div>

        <div style={{ marginLeft: "2rem" }}>
          <FormControl size="small">
            <Select
              labelId="select-event-label"
              value={selectedEventId ?? ""}
              onChange={handleEventChange}
              style={{ width: 400, ...FONT_STYLE }}
              displayEmpty
            >
              {events.map((ev) => (
                <MenuItem key={ev.id} value={ev.id} sx={FONT_STYLE}>
                  {" "}
                  {ev.name}
                </MenuItem>
              ))}

              {events.length === 0 && (
                <MenuItem disabled value="" sx={FONT_STYLE}>
                  Loading events…
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <IconButton onClick={handleMenuOpen} style={{ padding: "4px" }}>
          <FaUserCircle color={"gray"} style={{ fontSize: 29 }} />
        </IconButton>
        <div style={{ marginLeft: "5px", cursor: "pointer", ...FONT_STYLE }} onClick={handleMenuOpen}>
          {profile?.fullName}
        </div>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleLogout} sx={FONT_STYLE}>
            <FaArrowCircleRight style={{ marginRight: 8 }} />
            Logout
          </MenuItem>
        </Menu>
      </div>
    </header>
  );
};

export default Header;
